'use client';

import { useEffect } from 'react';
import { updateDataDogContext } from '~/utilities/datadog';

type OwnProps = {
  correlationId: string;
};

/**
 * Client component that updates DataDog RUM context with the current page's correlationId.
 * Used by CorrelationIdUpdater server component to ensure DD RUM tracking is updated
 * on each SPA navigation with the server-generated correlationId.
 */
export default function DatadogRumSyncClient({ correlationId }: OwnProps) {
  useEffect(() => {
    updateDataDogContext('correlationId', correlationId);
  }, [correlationId]);

  return null;
}
